export async function getPublicIP() {
  try {
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    return (await data.ip) as string;
  } catch (error) {
    console.error('Error al obtener la dirección IP:', error);
    return null;
  }
}
